import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { httpGet } from '@office-start/xhr-service';
function updateWorkloadPublicDataConfigCache(config) {
    var queryKey = ['WorkloadPublicDataConfig'];
    queryCache.cancelQueries(queryKey);
    queryCache.setQueryData(queryKey, config);
}
/**
 * Get workloadPublicData from Consumer Shell service with the option to forceRefresh the cache and
 * update the WorkloadPublicDataConfig query cache with the latest.
 * Setting the forceRefresh flag forces Shell to query FPC and return the data as opposed to fetching it
 * from Cosmos.
 * ForceRefresh should only be set post discussion with the Shell team as it can lead to throttling in the
 * downstream dependencies (AAD).
 * @param forceRefresh boolean to forceRefresh the CSS cache
 * @returns Promise with a WorkloadPublicDataConfig
 */
export function fetchAndUpdateWorkloadPublicDataConfig(forceRefresh) {
    return __awaiter(this, void 0, void 0, function () {
        var componentContext, identity, requestConfig, url;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    componentContext = _b.sent();
                    return [4 /*yield*/, componentContext.getIdentity()];
                case 2:
                    identity = _b.sent();
                    requestConfig = {
                        headers: (_a = {
                                accept: 'application/json'
                            },
                            _a["X-OfficeHome-UserId" /* OfficeHeader.UserId */] = identity.puid,
                            _a["X-OfficeHome-TenantId" /* OfficeHeader.TenantId */] = identity.tenantId,
                            _a),
                    };
                    url = "".concat(componentContext.officeHomeApiRoot, "/api/workloadpublicdata/consumer");
                    if (forceRefresh) {
                        url = "".concat(url, "?forceRefresh=true");
                    }
                    return [2 /*return*/, httpGet(KnownInstrumentationEvents.OfficeConsumerWorkloadPublicDataFetch, "Office_Consumer_Workload_Public_Data_Fetch" /* KnownRequestInstrumentationEvents.OfficeConsumerWorkloadPublicDataFetch */, url, requestConfig, componentContext.jwtAuthEnabled, componentContext.getAccessToken, componentContext.officeHomeApiRoot, componentContext.correlationId, 'OfficeHome')
                            .then(function (response) {
                            if (!response.data) {
                                var errMsg = 'No data returned from Consumer workload public data endpoint';
                                throw new Error(errMsg);
                            }
                            updateWorkloadPublicDataConfigCache(response.data);
                            return response.data;
                        })
                            .catch(function (error) {
                            logError({
                                eventName: KnownInstrumentationEvents.OfficeConsumerWorkloadPublicDataFetch,
                                message: "Failed to get consumer workload public data with error: ".concat(error),
                            });
                            return undefined;
                        })];
            }
        });
    });
}
//# sourceMappingURL=fetchAndUpdateWorkloadPublicDataConfig.js.map